var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "novel-editor-list" },
    [
      _c("div", { staticClass: "head" }, [
        _c("div", { staticClass: "controller" }, [
          _c(
            "div",
            {
              staticClass: "folder",
              on: {
                click: function ($event) {
                  return _vm.backToFolderList()
                },
                mouseenter: _vm.onFolderMouseEnter,
                mouseleave: _vm.hideFolderTooltip,
              },
            },
            [
              _c("img", {
                staticClass: "folder-icon",
                attrs: { src: require("@/assets/img/icon/folder_black.png") },
              }),
            ]
          ),
          _c("div", { staticClass: "title ellipsis" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.folder
                    ? _vm.folder.name
                    : _vm.$t("manuscriptPage.manuscriptList.allManuscripts")
                ) +
                " "
            ),
          ]),
          _c(
            "div",
            { staticClass: "menu" },
            [
              _vm.isEditMode || _vm.isDeleteMode || _vm.isMoveFolderMode
                ? [
                    _c(
                      "span",
                      { staticClass: "edit-end", on: { click: _vm.saveOrder } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("manuscriptPage.manuscriptList.editEnd")
                          )
                        ),
                      ]
                    ),
                  ]
                : [
                    _c("CogIcon", {
                      staticClass: "flex flex-center",
                      on: {
                        click: function ($event) {
                          _vm.isShowMenu = !_vm.isShowMenu
                        },
                      },
                    }),
                  ],
            ],
            2
          ),
        ]),
        _vm.isShowMenu
          ? _c(
              "div",
              {
                staticClass: "hover-menu-mask",
                on: { click: _vm.onClickCloseMenu },
              },
              [
                _c("div", { staticClass: "hover-menu" }, [
                  _c(
                    "div",
                    {
                      staticClass: "hover-menu-item",
                      on: { click: _vm.onClickSortManuscript },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "manuscriptPage.manuscriptList.sortManuscript"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "hover-menu-item",
                      on: { click: _vm.onClickMoveManuscript },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("manuscriptPage.manuscriptList.moveFolder")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "hover-menu-item",
                      on: { click: _vm.onClickImportFile },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "manuscriptPage.manuscriptList.importManuscript"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "hover-menu-item",
                      on: { click: _vm.toggleProgressDisplayMode },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "manuscriptPage.manuscriptList.changeProgressDisplay",
                              {
                                unit: _vm.isProgressPercentage
                                  ? _vm.$t(
                                      "manuscriptPage.manuscriptList.characters"
                                    )
                                  : _vm.$t(
                                      "manuscriptPage.manuscriptList.percentage"
                                    ),
                              }
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "hover-menu-item",
                      on: { click: _vm.onClickDeleteManuscript },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "manuscriptPage.manuscriptList.deleteManuscript"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "hover-menu-item close" }, [
                    _vm._v(
                      _vm._s(_vm.$t("manuscriptPage.manuscriptList.closeMenu"))
                    ),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _c("div", { staticClass: "writing-progress" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.$t("manuscriptPage.manuscriptList.totalCharacters", {
                  count: _vm.formattedTotalWordLength,
                })
              )
            ),
          ]),
          !_vm.folder
            ? _c("span", { staticClass: "remaining-progress" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("manuscriptPage.manuscriptList.remaining", {
                      count: _vm.remainingCharacterCount,
                      percent: _vm.remainingProgress,
                    })
                  )
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isFree && _vm.isFolderTooltipVisible,
              expression: "isFree && isFolderTooltipVisible",
            },
          ],
          ref: "folderTooltip",
          staticClass: "folder-premium-tooltip",
          style: {
            top: _vm.folderTooltipPosition.top + "px",
            left: _vm.folderTooltipPosition.left + "px",
          },
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("exportManuscriptDialog.premiumOnly")) + " "
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "list" },
        [
          _c("sortable-list", {
            staticClass: "list-container",
            attrs: {
              items: _vm.manuscripts,
              keyAttr: "key",
              disabled: !_vm.isEditMode,
              extra: _vm.isEditMode,
            },
            on: {
              "update:items": function ($event) {
                _vm.manuscripts = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ item, extra }) {
                  return [
                    _c("list-item", {
                      attrs: {
                        icon: "none",
                        label:
                          item.title ||
                          _vm.$t("manuscriptPage.manuscriptList.untitled"),
                        folderName: _vm.folderName(item),
                        isActive: _vm.selected && item.key === _vm.selected.key,
                        showHandle: extra,
                        item: item,
                        customClickFunction: () => _vm.select(item.key),
                        needsDoCustomClickFunction: true,
                        showProgress: true,
                        progress: _vm.unitProgress(item.content),
                        progressWidth: _vm.progressChipMinWidthValue(
                          item.content
                        ),
                        showContentWarning:
                          item.contentLoaded &&
                          item.contentStatus &&
                          item.contentStatus !== "PRESENT",
                        isEditMode: _vm.isEditMode,
                        isManuscriptDeleteMode: _vm.isDeleteMode,
                        isManuscriptMoveFolderMode: _vm.isMoveFolderMode,
                      },
                      on: {
                        clickSetFolder: _vm.setFolder,
                        delete: function ($event) {
                          _vm.deleteManuscript(
                            item.key,
                            item.title ||
                              _vm.$t("manuscriptPage.manuscriptList.untitled")
                          )
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm.isMobileDevice
            ? _c(
                "button",
                {
                  staticClass: "sp-create-button",
                  on: {
                    click: function ($event) {
                      return _vm.createManuscript()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("manuscriptPage.manuscriptList.newCreate")
                      ) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      !_vm.isMobileDevice
        ? _c("div", { staticClass: "button-container" }, [
            _c(
              "div",
              { staticClass: "button", on: { click: _vm.handleCreateClick } },
              [
                _c("div", { staticClass: "button-icon" }, [_c("icon-plus")], 1),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("manuscriptPage.manuscriptList.newAdd"))
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "button", on: { click: _vm.handlePreviewClick } },
              [
                _c(
                  "div",
                  { staticClass: "button-icon preview-icon" },
                  [_c("icon-preview")],
                  1
                ),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("manuscriptPage.manuscriptList.preview"))
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "button",
                on: { click: _vm.handleProperNounClick },
              },
              [
                _c(
                  "div",
                  { staticClass: "button-icon" },
                  [_c("icon-proper-noun")],
                  1
                ),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("manuscriptPage.manuscriptList.properNoun"))
                  ),
                ]),
              ]
            ),
            !_vm.isScriptMode
              ? _c(
                  "div",
                  {
                    staticClass: "button",
                    class: { active: _vm.isAssistPanelVisible },
                    on: { click: _vm.handleAssistClick },
                  },
                  [
                    _c("div", { staticClass: "assist-icon" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.assistIconSrc,
                          alt: _vm
                            .$t("manuscriptPage.manuscriptList.assistIconAlt")
                            .toString(),
                        },
                      }),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("manuscriptPage.manuscriptList.assist"))
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.isProperNounModalOpen
        ? _c("proper-noun-modal", {
            attrs: { novelId: _vm.novelId },
            on: {
              close: function ($event) {
                _vm.isProperNounModalOpen = false
              },
            },
          })
        : _vm._e(),
      _c("input", {
        ref: "input",
        staticStyle: { display: "none" },
        attrs: { type: "file", accept: ".txt,.docx", multiple: "" },
        on: {
          change: function ($event) {
            return _vm.onSelectFile()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }